(function (upp) {
    'use strict';
    upp
        //Controller for template "/categories/plugins/orders/orders.html", url "/account/orders/"
        .controller('upp.plugins.orders.OrdersCtrl', ['$scope', 'ordersService', 'appi', 'customerFieldType',
        function ($scope, ordersService, appi, customerFieldType) {
            appi.security.securable({scope:$scope})
                .then(function () {

                    appi.ui.changeActualOption({i18n:'MY-ORDERS.TITLE'});

                    appi.ui.showPageLoadingMsg();

                    $scope.$PAYMENT_PAYPAL = 1;
                    $scope.$PAYMENT_REFUND = 2;
                    $scope.$PAYMENT_WIRE_TRANSFER = 3;
                    $scope.$PAYMENT_REDSYS = 4;
                    $scope.$PAYMENT_PICK_AT_STORE = 5;

                    ordersService.listOrders()
                        .then(function (response) {
                            var data = response.data;

                            $scope.loaded = true;
                            $scope.orders = Array.from(data.orders).reverse();
                            $scope.currency = data.currency;
                            appi.ui.hidePageLoadingMsg();

                            $scope.openDetail = function (order) {
                                if (order.detailed) {
                                    // Hide/show detail section
                                    order.showDetail = !order.showDetail;
                                } else {
                                    // search for the info and show
                                    ordersService.retrieveOrder(order.id)
                                        .then(function (response) {
                                            var detail = response.data;
                                            order.products = detail.products;
                                            order.shippingAddress = detail.shippingAddress;
                                            order.billingAddress = detail.billingAddress;
                                            order.notes = detail.notes;
                                            order.shippingCharges = detail.shippingCharges;
                                            order.pickAtStoreOptions = detail.pickAtStoreOptions;
                                            order.price = detail.price;
                                            order.paymentModel = detail.paymentModel;

                                            order.detailed = true;
                                            order.showDetail = true;
                                        }, function () {
                                            //TODO: Show error message
                                            //order.noDetail = true;
                                        });
                                }
                            }
                        }, function () {
                            appi.ui.showNetworkError();
                        });

                });
        }])
    ;
})(upp);



// WEBPACK FOOTER //
// ./src/app/plugins/orders/controllers/orders-controller.js